<template>
  <div class="full-width full-height" v-if="error">
    <div class="bg-grey-11 q-py-sm q-px-md rounded-borders column flex-center">
      <p>{{ $t('Something went wrong !') }}</p>
      <div>
        <CButton
          v-if="hasRetry == true"
          icon="replay"
          color="primary"
          :label="$t('Click to retry')"
          @click="handleRetry"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <slot />
  </div>
</template>
<script>
import CButton from '@/components/uikit/CButton';
export default {
  name: 'ErrorBoundary',
  props: ['hasRetry', 'stateError'],
  data: () => ({
    error: false,
  }),
  // eslint-disable-next-line no-unused-vars
  errorCaptured(_err, _vm, _info) {
    this.error = true;
  },
  components: { CButton },
  watch: {
    stateError(val) {
      this.error = val;
    },
  },
  methods: {
    handleRetry() {
      this.$emit('retry');
    },
  },
};
</script>
